import React from "react";
import PropTypes from "prop-types";
import CryptoJS from "crypto-js";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";


import LoadingOverlay from "react-loading-overlay";
import "assets/scss/styles.css";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// PowerBi Inport 
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './powerBiCustom.css'
import handlePowerBiReport from "../../util/powerBi/handlePowerBiReport";
import { getCurrentJwt } from "../../util/jwt/decryptToken";

class PowerBiDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
      height: "1000px",
      localStorageClientId: "",
      powerBIEmbed: {
        report_id: props.appId,
        embed_url: undefined,
        embed_token: undefined,
      }
    };
  }

  getLastSegment(url) {
    // Use regex to match everything after the last '/'
    const match = url.match(/\/([^\/]*)$/);
    return match ? match[1] : url; // Return the captured group or the original string
  }

  componentDidMount() {
    // FETCH - POWER BI EMBED REPORTS
    if(localStorage.getItem("powerBiInfo") !== null) {
      let powerBiAuthInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("powerBiInfo"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      let powerBiInisghts = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("powerBiInsights"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      
      // Matching Reports
      for(let report of powerBiInisghts.reports.value) {
        if(report.name.replace(' ', '-') === this.getLastSegment(window.location.href) ) {
          powerBiAuthInfo['report_id'] = report.id
        }
      }
      
      // Fetch Proper Report based on window name
      handlePowerBiReport(powerBiAuthInfo, getCurrentJwt()).then(data => {
        this.setState({
          isActive: false,
          powerBIEmbed: data,
        })
      })
    }
    else {
      console.log("INSIGHT ERROR")
    }
  }

  render() {
    let pageSize = 12;
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text="Loading Charts..."
      >
        <GridContainer spacing={0}>
          <GridItem xs={pageSize} sm={pageSize} md={pageSize} xl={pageSize}>
            <div className="" style={{ padding: "0 50px !important" }}>
            <PowerBIEmbed
                embedConfig = {{
                type: 'report',   // Supported types: report, dashboard, tile, visual, qna and paginated report
                id: this.state.powerBIEmbed.report_id,
                embedUrl: this.state.powerBIEmbed.embed_url,
                accessToken: this.state.powerBIEmbed.embed_token,
                tokenType: models.TokenType.Embed
                }}
                cssClassName = { "powerBiCustom" }
                />
            </div>
          </GridItem>
        </GridContainer>
      </LoadingOverlay>
    );
  }
}

PowerBiDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(PowerBiDashboard);



// WEBPACK FOOTER //
// ./src/components/PowerBiInsights/powerBiDashboard.jsx